






































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import SwiperNews from "@/zh-website/src/components/website/Swiper/SwiperNews.vue";
import SwiperCase from "@/zh-website/src/components/website/Swiper/SwiperCase.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import Dynamic from "@/zh-website/src/components/website/Dynamic.vue";
// 引入背景组件
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
import { DigitalService } from "@/zh-website/src/views/Enterprise/service/DigitalService";
import { ProductService } from "@/zh-website/src/views/Enterprise/service/ProductService";
import { IndustryService } from "@/zh-website/src/views/Enterprise/service/IndustryService";

@Component({
  components: {
    SideBar,
    Swiper,
    SwiperSlide,
    SwiperNews,
    Banner,
    Dynamic,
    SwiperCase
  }
})
export default class ProductIndex extends Vue {
  dynamicList = {
    title: "培训动态",
    list: [] as any
  };
  // 背景图样式文案
  list: any = {
    style: {
      "background-image": `url(${require("../../assets/8.jpg")})`,
      height: "493px"
    },
    font1: "产品技术培训",
    font2: "数字技术为人才发展赋能",
    font3: "",
    font4: "",
    font5: "",
    button: ""
  };
  rightNew = [];
  leftNew = {};
  caseList: any[] = [];
  newjump = "/home/news/det/";
  caseJump = "";
  swiperOption = {
    direction: "horizontal",
    loop: true,
    centeredSlides: true,
    slidesPerView: "auto",
    spaceBetween: "5%",
    effect: "coverflow",
    autoplay: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 2,
      slideShadows: false
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  };
  showImg = true;
  // 行业分类介绍
  ProductList: any = [];
  // 行业首页成功案例
  successList = [
    {
      dictName: "数字政府",
      content1: "华为携手兰州新区共建“智慧城市ICT人才发展” 顶层设",
      field3: require("../../assets/success3.png")
    },
    {
      dictName: "金融",
      content1: "敏捷咨询助力民生银行全国网络运维人员定制化技能提升",
      field3: require("../../assets/success1.png")
    },
    {
      dictName: "交通",
      content1: "铁路训战课程助力成都局集团有限公司无线专家培养",
      field3: require("../../assets/success2.png")
    }
  ];

  mounted() {
    const _this = this;
    _this._getRightNew();
    _this.getTran();
    this._getSuccessList();
    this._getCaseList();
    this.getClassificationList();
    // //鼠标覆盖停止自动切换
    // mySwiper.el.onmouseover = function() {
    //   mySwiper.autoplay.stop();
    // };

    // //鼠标离开开始自动切换
    // mySwiper.el.onmouseout = function() {
    //   mySwiper.autoplay.start();
    // };
  }

  // 获取培训动态
  async _getDynamic() {
    ProductService.getTrainingNewsList({ type: 2 }).then((res: any) => {
      this.dynamicList.list.length = 0;
      res.data.list.forEach((item: any) => {
        this.dynamicList.list.push(item.publishTime + " " + item.content);
      });
    });
  }
  // 获取行业人才发展类别
  async _getCaseList() {
    // let { data: result } = await this.$ajax.get(
    //     "/webAction/list/huawei_dict?group=037"
    // );
    const arr = [
      {
        id: 1,
        keywords: require("../../assets/industryfen1.png"),
        dictName: "金融行业",
        extend1:
          "整合大数据、AI等前沿技术方向进行人才培养，从技术支撑到科技引领业务，助力银行数字化转型。",
        link: "/enterprise/develop/finance"
      },
      {
        id: 2,
        keywords: require("../../assets/industryfen1.png"),
        dictName: "电力行业",
        extend1:
          "聚焦能源互联网发展方向，通过自上而下的数字化人才储备与转型服务，携手推进电力物联网建设、数字难忘业务落地。",
        link: "/enterprise/develop/personnel"
      },
      {
        id: 4,
        keywords: require("../../assets/industryfen1.png"),
        dictName: "数字政府",
        extend1:
          "基于政务云、大数据、网络安全、新型智慧城市为特征的政府行业数字化人才发展需求，提供整体解决方案。",
        extend2: "",
        link: "/enterprise/develop/government"
      }
    ];
    // this.ProductList.push(...arr);
  }
  //右侧新闻动态
  async _getRightNew() {
    NewsService.getNewsList({ pageNum: 1, pageSize: 5, timeFrameCode: 1 }).then(
      (res: any) => {
        if (res.data.list.length > 0) {
          this.leftNew = res.data.list[0];
          this.rightNew = res.data.list.slice(1, res.data.list.length);
        } else {
          this.leftNew = {};
          this.rightNew = [];
        }
      }
    );
  }
  getClassificationList() {
    //
    ProductService.getClassification({ type: 2 }).then((res: any) => {
      res.data.list.forEach((item: any) => {
        this.ProductList.push({
          keywords: item.resourceUrl,
          link: item.jumpLink,
          id: item.id,
          dictName: item.title,
          extend1: item.subtitle
        });
      });
    });
  }
  // 获取首页成功案例
  async _getSuccessList() {
    // const _this = this;
    // try {
    //   const res = await this.$ajax.get(
    //       "/webAction/list/huawei_data?group=043&search=037&page=1&limit=5&sort=0&tag1=1"
    //   );
    //   this.successList = res.data.result.data;
    //   this.successList.forEach(item => {
    //     const list = JSON.parse(window.sessionStorage.getItem("Product"));
    //     item.field1 = "";
    //     item.field3 =
    //         "background-image:url('" +
    //         _this.$store.state.homeUrl +
    //         item.field3 +
    //         "')";
    //     // item.field2 = "";
    //     return (item.dictName = list[item.dictCode]);
    //   });
    //   this.caseJump = "/enterprise/comprehensive/datail?id=";
    //   _this.caseList = this.successList;
    // } catch (err) {
    //   console.log(err);
    // }
    ProductService.getSuccessCase({ navigationId: 2 }).then((res: any) => {
      res.data.list.forEach((item: any) => {
        this.caseList.push({
          dictName: item.classificationName,
          content1: item.title,
          field1: item.title,
          id: `all-success-case/detail/${item.id}`,
          field3: `background-image:url("${item.resourceUrl}")`
        });
      });
    });
  }
  getTran() {
    // this.$ajax
    //     .get(
    //         "/webAction/list/huawei_data?group=040&dictCode=040044&page=1&limit=20",
    //         {}
    //     )
    //     .then(res => {
    //       if (res.data.code == 1) {
    //         console.log(res);
    //         res.data.result.data.forEach((item, i) => {
    //           console.log(item);
    //           this.dynamicList.list[i] = item.field2 + " " + item.field1;
    //         });
    //       }
    //     });
  }
  on_top_enter() {
    (this.$refs.mySwiper as any).$swiper.autoplay.stop();
  }
  on_top_leave() {
    (this.$refs.mySwiper as any).$swiper.autoplay.start();
  }
}
